// TODO: Better error handling
// Aborting a fetch will throw an AbortError

export function get(url, options) {
  return fetch(url, {
    method: 'GET',
    ...options,
  });
}

export function post(url, data, options) {
  return fetch(url, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(data),
    ...options,
  });
}
